import http from '@/plugins/axios/axios';

export default class FuncionarioService {    

    buscar(requisicao, params) {        
        let p = params ? '?' + params : '';
        return http.post('/api/v1/app/funcionario/dados' + p, requisicao);
    } 
    
    alterarSenha(requisicao, params) {        
        let p = params ? '?' + params : '';
        return http.post('/api/v1/app/funcionario/alterar-senha' + p, requisicao);
    }
    
    gerarCodigoRecupararSenha(requisicao, params) {        
        let p = params ? '?' + params : '';
        return http.post('/api/v1/app/funcionario/codigo-recuperar-senha' + p, requisicao);
    }

    recuperarSenha(requisicao, params) {        
        let p = params ? '?' + params : '';
        return http.post('/api/v1/app/funcionario/recuperar-senha' + p, requisicao);
    }
}